import { gql } from '@apollo/client';

// ============================================================================
// QUERIES
// ============================================================================

export const GET_MY_ORGANIZATIONS = gql`
  query GetMyOrganizations {
    myOrganizations {
      id
      name
      slug
      plan
      maxMembers
      maxProjects
      maxContexts
      memberCount
      projectCount
      contextCount
      createdAt
    }
  }
`;

export const GET_ORGANIZATION = gql`
  query GetOrganization($id: ID!) {
    organization(id: $id) {
      id
      name
      slug
      description
      plan
      maxMembers
      maxProjects
      maxContexts
      createdAt
    }
  }
`;

export const GET_ORGANIZATION_MEMBERS = gql`
  query GetOrganizationMembers($organizationId: ID!) {
    organizationMembers(organizationId: $organizationId) {
      id
      userId
      email
      role
      status
      joinedAt
    }
  }
`;

export const GET_ORGANIZATION_USAGE = gql`
  query GetOrganizationUsage($organizationId: ID!) {
    organizationUsage(organizationId: $organizationId) {
      currentMembers
      currentProjects
      currentContexts
      limits {
        maxMembers
        maxProjects
        maxContexts
        canInviteMembers
        hasRBAC
      }
      memberUsagePercent
      projectUsagePercent
      contextUsagePercent
    }
  }
`;

export const GET_MY_PROJECTS = gql`
  query GetMyProjects {
    myProjects {
      id
      organizationId
      name
      slug
      description
      color
      contextCount
      createdAt
    }
  }
`;

export const GET_ORGANIZATION_PROJECTS = gql`
  query GetOrganizationProjects($organizationId: ID!) {
    organizationProjects(organizationId: $organizationId) {
      id
      organizationId
      name
      slug
      description
      color
      contextCount
      createdAt
    }
  }
`;

export const GET_PROJECT = gql`
  query GetProject($id: ID!) {
    project(id: $id) {
      id
      organizationId
      name
      slug
      description
      color
      createdAt
    }
  }
`;

export const GET_PROJECT_MEMBERS = gql`
  query GetProjectMembers($projectId: ID!) {
    projectMembers(projectId: $projectId) {
      id
      userId
      email
      role
      addedAt
    }
  }
`;

// ============================================================================
// MUTATIONS
// ============================================================================

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      id
      name
      slug
      plan
      maxMembers
      maxProjects
      maxContexts
    }
  }
`;

export const INVITE_TO_ORGANIZATION = gql`
  mutation InviteToOrganization($input: InviteMemberInput!) {
    inviteToOrganization(input: $input) {
      id
      token
      inviteLink
      email
      role
      expiresAt
    }
  }
`;

export const ACCEPT_INVITATION = gql`
  mutation AcceptInvitation($input: AcceptInvitationInput!, $email: String!) {
    acceptInvitation(input: $input, email: $email) {
      id
      userId
      email
      role
      status
      joinedAt
    }
  }
`;

export const UPDATE_ORGANIZATION_MEMBER_ROLE = gql`
  mutation UpdateOrganizationMemberRole($input: UpdateMemberRoleInput!) {
    updateOrganizationMemberRole(input: $input)
  }
`;

export const REMOVE_ORGANIZATION_MEMBER = gql`
  mutation RemoveOrganizationMember($organizationId: ID!, $userId: ID!) {
    removeOrganizationMember(organizationId: $organizationId, userId: $userId)
  }
`;

export const CREATE_PROJECT = gql`
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      id
      organizationId
      name
      slug
      description
      color
    }
  }
`;

export const ADD_PROJECT_MEMBER = gql`
  mutation AddProjectMember($input: AddProjectMemberInput!) {
    addProjectMember(input: $input) {
      id
      userId
      email
      role
      addedAt
    }
  }
`;

export const UPDATE_PROJECT_MEMBER_ROLE = gql`
  mutation UpdateProjectMemberRole($input: UpdateProjectMemberRoleInput!) {
    updateProjectMemberRole(input: $input)
  }
`;

export const REMOVE_PROJECT_MEMBER = gql`
  mutation RemoveProjectMember($projectId: ID!, $userId: ID!) {
    removeProjectMember(projectId: $projectId, userId: $userId)
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: ID!) {
    deleteProject(id: $id)
  }
`;
